import { Button, Col, Modal, Row, Select, Table, Radio, Image, notification } from 'antd';
// import { Option } from 'antd/lib/mentions';
import React, { useState, useEffect } from 'react';
import { fetchData, sendData } from '../../httpRequests';

const { Option } = Select;
const form = {
    adsAdmin: [],
    pharmacies_id: null
}
export default function AddAdsToPharmacy() {
    const [isModalVisibleAdd, setIsModalVisibleAdd] = useState(false);
    const [fharmacies, setFharmacies] = useState([]);
    const [fharmaciesName, setFharmaciesName] = useState([]);
    const [formValues, setFormValues] = useState(form)
    const [selectionType, setSelectionType] = useState('checkbox');
    const [ads, setAds] = useState([]);
    const [ads2, setAds2] = useState([]);
    const [other, setOther] = useState([]);
    const [tbLoading, setTbLoading] = useState(false)

    const { adsAdmin, pharmacies_id } = formValues

    const showModalAdd = () => {
        getAdsFarmacy()
        getAdsFarmacy2()
        setIsModalVisibleAdd(true)

    }
    const handleCancel = () => {
        setIsModalVisibleAdd(false)
    }

    const getFharmacies = () => {
        const url = '/pharmacies/getPharmacies';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const farmacies = response['pharmacy'];
                setFharmacies(farmacies)
                setFharmaciesName(farmacies)
            }
        })
    }
    const getAdsFarmacy = () => {
        setAds([])
        setAds2([])
        setTbLoading(true)
        const id = localStorage.getItem('PHARMACY_LOGGED')
        const url = `/advertisements/getAdsByfarmacyId/${id}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const ads = response['ads'];
                setAds(ads)
                setAds2(ads)
                setTbLoading(false)
            }
        })
    }

    const getAdsFarmacy2 = () => {
        setOther([])
        const id = localStorage.getItem('PHARMACY_LOGGED')
        const url = `/advertisements/getAdsByfarmacyId/${id}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const ads = response['ads'];
                setOther(ads)
            }
        })
    }
    const saveAds = () => {
        let data = []
        formValues.adsAdmin.forEach(e => {
            data.push({ ads_id: e.id, pharmacy_id: formValues.pharmacies_id })
        })
        const url = '/advertisements/createAdminAdsToPharmacy';
        sendData(url, { data }).then(async (response) => {
            if (response.ok) {
                handleCancel()
                openNotificationWithIcon('success', response.msg)
                setFormValues({
                    ...formValues,
                    pharmacies_id: null
                })
                getAdsFarmacy()
                getAdsFarmacy2()
            }
        })

    }

    useEffect(() => {
        getFharmacies()
        getAdsFarmacy()
        getAdsFarmacy2()
    }, [])

    const handleFilterPhamacies = async (e) => {
        console.log(e)
        await getAdsFarmacy()
        await getAdsFarmacy2()
        setTbLoading(true)
        const url = `/advertisements/getAdminAdsToPharmacyByPharmacy/${e}`;
        fetchData(url).then(async (response) => {
            setTbLoading(true)
            if (response.ads.length > 0) {
                response.ads.forEach((e) => {
                    let index = other.findIndex(ele => {
                        return ele.id == e.ads_id
                    })
                    other.splice(index, 1)
                })
                await setAds(other)
                await setAds2(other)
                setTbLoading(false)
            } else {
                await getAdsFarmacy()
            }

        })
        setFormValues({
            ...formValues,
            pharmacies_id: e
        })
    }

    const columns = [
        {
            title: 'NAME',
            dataIndex: 'name',

        },
        {
            title: 'CATEGORY',
            dataIndex: 'category_name',
        },
        {
            title: 'IMG',
            render: ({ img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={img} />
                </div>
            )
        },
    ];
    const onSearch = (value) => {
        let text = value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        console.log('search:', text);
        if (text) {
            const filterePharmacy = fharmacies.filter(phar => {
                return phar.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().includes(text.toLowerCase())
            })
            console.log(filterePharmacy)
        }
    };

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setFormValues({
                ...formValues,
                adsAdmin: selectedRows
            })
        },

    };

    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };
    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Col span={24}>
                    <Button
                        onClick={showModalAdd}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        {/* <PlusOutlined /> */}
                        Add ads to pharmacy
                    </Button>
                </Col>
            </Row>


            <Modal title="Add ads to fharmacy"
                visible={isModalVisibleAdd}
                onCancel={handleCancel}
                width={700}
                footer={null}
                closable={true}
            >
                <Row gutter={24} style={{ marginBottom: '20px' }}>
                    {/* <Col span={24}>
                        <Select showSearch style={{ width: '100%' }} size='large' name="pharmacies_id" value={pharmacies_id} onChange={handleFilterPhamacies} onSearch={onSearch}>
                            {fharmacies.map((c) => (
                                <Select.Option key={c.id} value={c.id}  >
                                    {c.name}
                                </Select.Option>
                            ))
                            }

                        </Select>
                    </Col> */}
                    <Col span={24}>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            size='large'
                            optionFilterProp="children"
                            onChange={handleFilterPhamacies}
                            // onSearch={onSearch}
                            placeholder='Pharmacy'
                            value={pharmacies_id}
                            filterOption={(input, option) => option.children[1].toLowerCase().includes(input.toLowerCase())}
                        >

                            {fharmacies.map((c) => (<Option value={c.id} key={c.id}> {c.name}</Option>))}

                        </Select>
                    </Col>
                    <Col span={24}>
                        <Radio.Group
                            onChange={({ target: { value } }) => {
                                setSelectionType(value);
                            }}
                            value={selectionType}
                        >


                        </Radio.Group>
                        <Table
                            rowSelection={{
                                type: selectionType,
                                ...rowSelection,
                            }}
                            columns={columns}
                            loading={tbLoading}
                            dataSource={ads2}
                            rowKey={(item) => item.id}

                        />
                    </Col>
                    <Col span={24}>
                        <Button

                            onClick={saveAds}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                            disabled={pharmacies_id == null || adsAdmin.length < 1}
                        >
                            {/* <PlusOutlined /> */}
                            Save Ads
                        </Button>
                    </Col>


                </Row>
            </Modal>
        </div >
    )
}